import { useEffect, useState } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import SearchBox from "@/components/feature/SearchBox";

const navItems = [
  { label: "首页", to: "/" },
  { label: "剧集", to: "/category/episodes" },
  { label: "演员", to: "/category/actors" },
  { label: "剧情解析", to: "/category/plots" },
  { label: "关于", to: "/about" },
];

export default function SiteHeader() {
  const location = useLocation();
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  const isHome = location.pathname === "/";

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
  }, [location.pathname]);

  const solid = !isHome || scrolled || menuOpen;

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        solid ? "border-b border-background-200 bg-background-50/95 backdrop-blur" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-site items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex shrink-0 items-center gap-2">
          <span
            className={`flex h-9 w-9 items-center justify-center rounded-md text-lg ${
              solid ? "bg-primary-500 text-background-50" : "bg-background-50/90 text-primary-600"
            }`}
          >
            <i className="ri-movie-2-line" />
          </span>
          <span className="flex flex-col leading-none">
            <span className={`text-base font-bold ${solid ? "text-foreground-950" : "text-background-50"}`}>
              年轻的母亲1
            </span>
            <span className={`text-[10px] tracking-widest ${solid ? "text-foreground-500" : "text-background-100/80"}`}>
              DRAMA ARCHIVE
            </span>
          </span>
        </Link>

        <nav className="hidden flex-1 items-center justify-center gap-1 md:flex">
          {navItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === "/"}
              className={({ isActive }) =>
                `whitespace-nowrap rounded-md px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? solid
                      ? "bg-primary-100 text-primary-700"
                      : "bg-background-50/20 text-background-50"
                    : solid
                      ? "text-foreground-600 hover:text-primary-600"
                      : "text-background-100/90 hover:text-background-50"
                }`
              }
            >
              {item.label}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden w-64 lg:block">
          <SearchBox />
        </div>

        <Link
          to="/category/episodes"
          className="ml-auto hidden whitespace-nowrap rounded-md bg-accent-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-accent-600 lg:ml-3 lg:block"
        >
          开始追剧
        </Link>

        <button
          type="button"
          onClick={() => setMenuOpen((prev) => !prev)}
          aria-label="打开菜单"
          className={`ml-auto flex h-10 w-10 items-center justify-center rounded-md text-xl md:hidden ${
            solid ? "text-foreground-800" : "text-background-50"
          }`}
        >
          <i className={menuOpen ? "ri-close-line" : "ri-menu-line"} />
        </button>
      </div>

      {menuOpen ? (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-5 pt-4 md:hidden">
          <div className="mb-4">
            <SearchBox />
          </div>
          <nav className="flex flex-col gap-1">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                end={item.to === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-medium transition-colors ${
                    isActive ? "bg-primary-100 text-primary-700" : "text-foreground-700 hover:bg-background-100"
                  }`
                }
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      ) : null}
    </header>
  );
}